export function DotIcon() {
  return (
    <svg width="4" height="4" viewBox="0 0 4 4" fill="none" aria-hidden="true">
      <circle cx="2" cy="2" r="2" fill="currentColor" fillOpacity="0.48" />
    </svg>
  );
}
